<table class="ticket-table" style="font-size: 0.85em; width: 100%">
  @for (item of ticketList; track item; let i = $index) {
    <tr>
      <td class="check-column">
        @if (!mustAppear(item) && item.ticket_balance > 0 && item.ticket_balance - item.pending_payment_total > 0) {
          <div
            >
            <dx-check-box [(value)]="item.selected_to_pay" (onValueChanged)="onSelectedChanged($event)"></dx-check-box>
          </div>
        }
        @if (item.ticket_balance - item.pending_payment_total === 0 && item.ticket_balance > 0) {
          <div>
            PENDING<br />PAYMENT
          </div>
        }
        <div style="display: flex; justify-content: center">
          {{ ticketStatus(item) }}
          @if (mustAppear(item)) {
            <img
              style="margin-left: 5px"
              class="pointer"
              src="{{ env.assetsPath }}images/Information_Red_16x16.png" />
          }
        </div>
      </td>
      <td class="standard-column">
        <div class="ticket-line" style="display: flex">
          <div class="data-label">{{ ticketTypeName(item.ticket_type) }}:</div>
          <div class="data-value">{{ item.ticket_number }}</div>
        </div>
      </td>
      <td class="standard-column">
        <div class="ticket-line" style="display: flex">
          <div class="data-label balance-label" style="white-space: nowrap">Balance Due:</div>
          <div class="data-value" style="display: flex; width: 100%">
            @if (!mustAppear(item)) {
              <div class="ticket-line" style="display: flex">
                <div>
                  {{ item.ticket_balance | currency: 'USD':'symbol' }}
                </div>
                @if (item.ticket_balance > 0 && !item.suspend_payment_due_date) {
                  <div>
                    &nbsp;by {{ item.payment_due_date | date: dateFormat }}
                  </div>
                }
                @if (isPastDue(item) && !item.suspend_payment_due_date) {
                  <div style="margin-left: 5px" class="past-due">
                    PAST DUE
                  </div>
                }
              </div>
            }
            @if (mustAppear(item) && item.calendar_datetime != null) {
              <div style="display: flex">
                Must appear in court by {{ item.calendar_datetime | date: dateFormat }}
              </div>
            }
            @if (mustAppear(item) && item.calendar_datetime == null) {
              <div style="display: flex">
                Must appear in court
              </div>
            }
            @if (item.payment_amount) {
              <div style="margin-left: 10px">
                <img
                  [id]="'pay' + item.ticket_id"
                  class="pointer"
                  src="{{ env.assetsPath }}images/Information_12x12.png" />
                  <dx-tooltip [target]="'#pay' + item.ticket_id" showEvent="dxclick">
                    <dxo-animation show="{}"></dxo-animation>
                    <div *dxTemplate="let tooltipData = data; of: 'content'" class="tooltip-wrap">
                      <div style="text-align: left">
                        <div class="data-label">Most recent payment</div>
                        <table>
                          <tr>
                            <td class="data-label">Receipt Number:</td>
                            <td class="data-value">{{ item.receipt_number }}</td>
                          </tr>
                          <tr>
                            <td class="data-label">Receipt Date:</td>
                            <td class="data-value">
                              {{ item.receipt_date | date: dateFormat }}
                            </td>
                          </tr>
                          <tr>
                            <td class="data-label">Payment Amount:</td>
                            <td class="data-value">
                              {{ item.payment_amount | currency: 'USD':'symbol' }}
                            </td>
                          </tr>
                          <tr>
                            <td class="data-label">Applied This Ticket:</td>
                            <td class="data-value">
                              {{ item.applied_amount | currency: 'USD':'symbol' }}
                            </td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </dx-tooltip>
                </div>
              }
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          <div style="display: flex">
            <div class="data-label">Location:</div>
            <div class="data-value">{{ item.violation_location }}</div>
          </div>
        </td>
        <td>
          <div style="display: flex">
            <div class="data-label">{{ action(item) }}</div>
            <div class="data-value">
              {{ actionDate(item) | date: actionDateFormat(item) }}
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          <div style="display: flex">
            <div class="data-label">Issue Date:</div>
            <div class="data-value">{{ item.offense_datetime | date: dateTimeFormat }}</div>
          </div>
        </td>
        <td>
          @if (item.ticket_type === 'T' || item.ticket_type === 'R') {
            <div style="display: flex">
              <div class="data-label">Defendant:</div>
              <div class="data-value">{{ item.defendant_first_name }} {{ item.defendant_last_name }}</div>
              @if (item.attorney_name) {
                <div>
                  <img
                    style="margin-left: 5px"
                    [id]="'att' + item.ticket_id"
                    class="pointer"
                    src="{{ env.assetsPath }}images/BriefCase-16x16.png" />
                  </div>
                }
              </div>
            }
            @if (item.ticket_type === 'P') {
              <div style="display: flex">
                <div class="data-label">Scofflaw:</div>
                @if (!item.is_scoffed) {
                  <div class="data-value">No</div>
                }
                @if (item.is_scoffed) {
                  <div style="color: red" class="data-value">Yes</div>
                }
              </div>
            }
          </td>
        </tr>
        <tr>
          <td></td>
          <td colspan="2">
            <div style="display: flex">
              <div class="data-label">Violation:</div>
              <div class="data-value" style="width: 100%">
                <div class="violation-row" style="display: flex; justify-content: space-between; align-items: center">
                  <div class="violation-main" style="display: flex; align-items: center">
                    {{ item.violation_code }}: {{ item.violation_code_description }}
                    @if (item.ticket_type === 'T' && item.speed_zone && item.speed_clocked) {
                      {{item.speed_zone}}/{{ item.speed_clocked }} ({{ item.speed_over_by }})
                    }
                    <div style="padding-left: 3px">
                      @if (item.violation_information) {
                        <img
                          (click)="showInformation(item)"
                          class="pointer"
                          src="{{ env.assetsPath }}images/Help_16x16.png" />
                      }
                    </div>
                    <div style="padding-left: 3px">
                      @if (item.violation_code !== item.violation_code_original) {
                        <img
                          [id]="'viol' + item.ticket_id"
                          class="pointer"
                          src="{{ env.assetsPath }}images/Information_16x16.png" />
                      }
                    </div>
                  </div>
                  <div></div>
                  <div class="license-and-plate">
                    {{ item.license_number }} {{ item.license_state }} {{ item.plate_number }}
                    {{ item.plate_state }}
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        @if (item.disposition_code) {
          <tr>
            <td></td>
            <td colspan="2">
              <div style="display: flex">
                <div class="data-label">Disposition:</div>
                <div class="data-value">{{ item.disposition_name }} on {{ item.disposition_date | date: dateFormat }}</div>
              </div>
            </td>
          </tr>
        }
        <tr>
          <td></td>
          <td>
            @if (item.in_collection) {
              <div class="sent-collection">Sent to Collection</div>
            }
          </td>
        </tr>
        @if (item.pending_payment_total > 0) {
          <tr>
            <td></td>
            <td style="font-weight: bold;font-size: 1.1em;">
              Pending Payment Amount {{item.pending_payment_total | currency: 'USD':'symbol'}}
            </td>
          </tr>
        }
        <tr>
          <td colspan="3">
            <dx-tooltip [target]="'#viol' + item.ticket_id" showEvent="dxclick">
              <dxo-animation show="{}"></dxo-animation>
              <div *dxTemplate="let tooltipData = data; of: 'content'" class="tooltip-wrap">
                <div style="text-align: left">
                  <div class="data-label">Original Violation</div>
                  <div>
                    {{ item.violation_code_original }}:
                    {{ item.violation_code_description_original }}
                  </div>
                </div>
              </div>
            </dx-tooltip>
            <dx-tooltip [target]="'#att' + item.ticket_id" showEvent="dxclick">
              <dxo-animation show="{}"></dxo-animation>
              <div *dxTemplate="let tooltipData = data; of: 'content'" class="tooltip-wrap">Attorney representation</div>
            </dx-tooltip>
          </td>
        </tr>
        @if (i + 1 !== ticketList.length) {
          <tr>
            <td colspan="3">
              <div style="border-bottom: 1px solid black; margin-bottom: 1px"></div>
            </td>
          </tr>
        }
      }
    </table>
    <app-plead-dialog #pleadDialog></app-plead-dialog>
    <app-violation-information-dialog #violationInfo></app-violation-information-dialog>
